export class TextTransformationModel {
  constructor(public target = '', public column = '', public transformation: 'LOWER' | 'UPPER' = 'LOWER') {}
}
